<template>
  <div class="c_table_wrap">
    <table class="memberInfo_table">
      <colgroup>
        <col width="200px;">
        <col width="">
      </colgroup>
      <tr>
        <td class="c_t_title">신청일</td>
        <td class="write_content_td">
          {{ memberData.created_at }}
<!--          <div>-->
<!--            {{ memberData.created_at }}-->
<!--          </div>-->
        </td>
      </tr>
      <tr>
        <td class="c_t_title">제목</td>
        <td class="write_content_td">
          <div class="write_content_div">
            <el-input type="textarea" id="title" rows="10" v-model="content"></el-input>
          </div>
        </td>
      </tr>
      <tr>
        <td class="c_t_title">경력 증빙 자료</td>
        <td class="write_content_td">
          <el-link type="black" class="mr20" v-if="checkFile()" @click="fileDown()" v-for="(data, index) in memberData.Files" :key="`file${index}`">
            {{ data.org_name }}
          </el-link>
        </td>
      </tr>
    </table>
    <div class="pa15 text-center btn_wrap">
      <el-button class="reg_btn_out" @click="$router.back()">목록</el-button>
      <el-button class="reg_btn_out" v-if="memberData.c_status == 0"
                 @click="runAllow('allow', memberData.c_idx)">승인</el-button>
      <el-button class="com_btn" v-if="memberData.c_status == 0"
                 @click="runAllow('refuse', memberData.c_idx)">거절</el-button>
    </div>
  </div>
</template>

<script>
import boardValidator from "@/mixins/validators/boardValidator";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";

export default {
  name: "MemberWriteCuratorLayout",
  mixins: [alertMixins, boardValidator],
  components: {
  },
  inject: ['changeAllow'],
  provide() {
    return{

    }
  },
  props: {
    memberData: {default: () => {}},
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.initSetData();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    initSetData() {
      this.content = this.memberData.c_context;
      this.parentChange('content', this.content);
      this.created_at = this.memberData.created_at;
      this.files = this.memberData.Files.org_name;
    },
    checkFile() {
      // return !util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files[0].org_url) && !util.isEmpty(this.memberData.BusinessFile[0].a_idx);
      return !util.isEmpty(this.memberData.Files) && !util.isEmpty(this.memberData.Files[0].org_url);
    },
    fileDown() {
      let file = this.memberData.Files[0];
      const anchor = document.createElement('a');

      anchor.href = file.org_url;
      anchor.style.display = 'none';
      anchor.target = '_blank'
      anchor.setAttribute('download', file.org_name);
      document.body.appendChild(anchor);
      anchor.click();
    },
    runAllow(type, key) {
      let text = type === 'allow' ? '정말 승인하시겠습니까?' : '정말 거절하시겠습니까?';
      this.createConfirm({
        content: text,
        confirm: () => {
          this.changeAllow(type, key)
        }
      })
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>